import React from 'react';
import { createRoot } from 'react-dom/client';

import FlightDisplay from './FlightDisplay';

// FLIGHTS MODULE
const flightDom = document.querySelector('#flightmodule');
if (flightDom) {
    const flightRoot = createRoot(flightDom);
    flightRoot.render(<FlightDisplay />);
}
